/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { profileDetail, walletDetail, transactionsDetails } from './test-data/profile.detail';

const is = require("is_js");

const { LoggerModule } = require("@vlinder-web/logger-module-react");
const SERVICE_NAME = "profile.service";
const log: any = LoggerModule.getInstance();

export class ProfileService {
    name = SERVICE_NAME;
    private static instance: ProfileService;
    private constructor() {
        this.report();
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new ProfileService();
        }
        return this.instance;
    }
    async init() {}

    

    async getProfileData() {
        let _profileData = profileDetail;
        return _profileData;
    }

    async getWalletData() {
        let _walletData = walletDetail;
        return _walletData;
    }

    // async getTransactionData() {
    //     let _transactionData = transactionsDetails;
    //     return _transactionData;
    // }

    async getTransactionData(size: number, offset: number) {
        let _found = transactionsDetails;
       _found = _found.slice(offset, offset + size);
       return {
           pagination: {
               nextOffset: offset + _found.length,
               totalItems: transactionsDetails?.length,  
           },
           results: _found,
       }
   }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
